import { UserApi } from 'infrastructure/apis/user/UserApi';
import { type IApplication } from './IAplication';
import axios from 'axios';
import { IUserStore, UserStore } from 'stores/user';
import { UserService } from './services/user';
import { AxiosClient } from 'infrastructure/axiosClient/AxiosClient';
import { CreativesStore, ICreativesStore } from 'stores/creatives';
import { CreativesApi } from 'infrastructure/apis/creatives/CreativesApi';
import { CreativesService } from './services/creatives';
import { CategoriesStore, ICategoriesStore } from 'stores/categories';
import { CategoriesApi } from 'infrastructure/apis/categories';
import { CategoriesService } from './services/categories';
import { TokenStorage } from 'infrastructure/storage';
import { IInstagramStore, InstagramStore } from 'stores/instagram';
import { InstagramApi } from 'infrastructure/apis/instagram';
import { InstagramService } from './services/instagram';
import { MediaApi } from 'infrastructure/apis/media';
import { CloudinaryApi } from 'infrastructure/apis/cloudinary';
import { MediaService, IMediaService } from './services/media';

export class Application implements IApplication {
  public static readonly instance: Application = new Application();

  public readonly userStore: IUserStore;
  public readonly creativesStore: ICreativesStore;
  public readonly categoriesStore: ICategoriesStore;
  public readonly instagramStore: IInstagramStore;
  public readonly mediaService: IMediaService;

  private constructor() {
    const _axios = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
    });

    const axiosClient = new AxiosClient(_axios);
    const tokenStorage = new TokenStorage();

    const userApi = new UserApi(axiosClient, tokenStorage);
    const userService = new UserService(userApi);
    this.userStore = new UserStore(userService);

    const creativesApi = new CreativesApi(axiosClient);
    const creativesService = new CreativesService(creativesApi);
    this.creativesStore = new CreativesStore(creativesService);

    const categoriesApi = new CategoriesApi(axiosClient);
    const categoriesService = new CategoriesService(categoriesApi);
    this.categoriesStore = new CategoriesStore(categoriesService);

    const instagramApi = new InstagramApi(axiosClient);
    const instagramService = new InstagramService(instagramApi);
    this.instagramStore = new InstagramStore(instagramService);

    const mediaApi = new MediaApi(axiosClient);
    const cloudinaryApi = new CloudinaryApi();
    this.mediaService = new MediaService(mediaApi, cloudinaryApi);
  }
}
